<template>
  <div class="about">
    <h1>This is an about page</h1>
  </div>
</template>

<script>
import i18n from '../i18n'

export default {
  name: 'About',
  title: i18n.locale === 'en' ? 'About us' : 'Για εμάς'
}
</script>
